// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filter-dropdown {
  cursor: pointer;
}

#dashboard-Heatmap-container {
  min-height: 75vh;
}`, "",{"version":3,"sources":["webpack://./src/app/dashboard/dashboard.component.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;AACJ;;AAEA;EACI,gBAAA;AACJ","sourcesContent":[".filter-dropdown {\n    cursor: pointer;\n}\n\n#dashboard-Heatmap-container {\n    min-height: 75vh;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
